module.exports = __webpack_public_path__ + "img/百香果5.d82ce5c1.png";